import { css } from '@emotion/react';
import { Banner, color, spacing, Typography } from '@uniquegood/realworld-studio-design';
import { ListStyleTypeDisc } from '@/styles';

function SimultaneousNoticeModal() {
  return (
    <div>
      <div
        css={css`
          margin-bottom: ${spacing.margin.xlarge2};
        `}
      >
        <Typography type="body">현재 다른 브라우저에서 채널에 접속 중이에요.</Typography>
        <Typography type="body">함께 작업할 때 아래 내용을 꼭 확인해 주세요.</Typography>
      </div>
      <Banner type="informational" header="동시 접속 유의사항">
        <ul
          css={[
            ListStyleTypeDisc,
            css`
              margin: 0;
              padding-left: ${spacing.padding.large};
              font-size: 14px;
              line-height: 20px;
              color: ${color.text_default};

              li {
                margin-bottom: ${spacing.margin.xsmall};

                &:last-child {
                  margin-bottom: 0;
                }
              }
            `
          ]}
        >
          <li>여러 명이 동시에 수정하면 마지막 저장본만 반영돼요.</li>
          <li>
            변경 사항이 실시간으로 보이지 않을 수 있어요. 새로고침으로 최신 내용을 확인해 주세요.
          </li>
          <li>같은 부분을 수정하면 작업이 덮어쓰기될 수 있으니 주의해 주세요.</li>
        </ul>
      </Banner>
    </div>
  );
}

export default SimultaneousNoticeModal;
